import React, { useCallback, useMemo } from "react";
import Button from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import DropDownButton from "devextreme-react/drop-down-button";
import { IJGHeader } from "./wh3";
import { useAppFusion, useReverseRoute } from "../../contexts";
import { Switch, Case, CaseElse } from "react-context-switch";
import { useDispatch, useSelector } from "react-redux";
import WindowHeadLine from "./wh0";
import { selectInsLogin } from "../../state/insider/login";
import * as appConst from "@app/state/constants";
import logo from "../../style/img/jurnalgold-icon-64x64.svg";
import "./appheader.scss";

import type { TInsLoginData } from "@app/types";

const headerHeight = appConst.SIZES.headerHeight;

export const AppHeader = () => {
  const insLogin: TInsLoginData = useSelector(selectInsLogin) || {
    LOGINCTX: "",
  };
  const { user, isAuthenticated, login, logout, register, isVerifiedEmail } =
    useAppFusion();

  const showJGHeader = useMemo(() => {
    const conda = insLogin.LOGINCTX !== "";
    if (!conda) {
      return false;
    }
    const condb = insLogin.LOGINCTX.includes("/");
    if (!condb) {
      return false;
    }
    const groupId = +insLogin.LOGINCTX.split("/")[0];
    const condc = !isNaN(groupId) && isFinite(groupId);
    if (!condc) {
      return false;
    }

    return condc && isAuthenticated && isVerifiedEmail;
  }, [insLogin, isAuthenticated, isVerifiedEmail]);

  // const {routes} = useReverseRoute('AppHeader');
  const LogoItem = () => {
    return (
      <div className="navbar__logo">
        <img src={logo} alt="Jurnal Gold Logo" className="navbar__logo__svg" />
      </div>
    );
  };

  const userDropDownOptions = {
    splitButton: true,
    useSelectMode: false,
    text: isAuthenticated ? user?.username || user.email : "Autentificare",
    items: isAuthenticated
      ? [
          {
            id: 1,
            name: "Profil",
            icon: "user",
            badge: !(user?.FIRST_NAME && user?.LAST_NAME)
              ? "incomplet"
              : undefined,
          },
          {
            id: 2,
            name: "Setari",
            icon: "preferences",
          },
          {
            id: 3,
            name: "Iesire",
            icon: "clear",
            onClick: () => {
              logout();
            },
          },
        ]
      : [
          {
            id: 10,
            name: "Inregistrare",
            icon: "unlock",
            onClick: () => {
              register();
            },
          },
        ],
    displayExpr: "name",
    keyExpr: "id",
    onButtonClick: () => {
      if (!isAuthenticated) login();
    },
    onItemClick: () => {
      console.log("onItemClick");
    },
  };

  return (
    <React.Fragment>
      <Switch value={showJGHeader}>
        <Case when={true}>
          <div id={"jgjs-topbar"}>
            <div id={"jgjs-header"}>
              <IJGHeader />
            </div>
            <WindowHeadLine />
          </div>
        </Case>
        <CaseElse>
          <div className="appheader">
            <LogoItem />
            <Toolbar className="appheader__toolbar">
              <Item
                location="before"
                widget="dxButton"
                options={{
                  elementAttr: {
                    class: "appheader__toolbar__button",
                  },
                  text: "Documentatie",
                  icon: "",
                  stylingMode: "text",
                  onClick: () => {
                    window.location.href =
                      process.env.NODE_ENV === "development"
                        ? `https://help.jurnalgold.ro`
                        : `https://help.jurnalgold.ro`;
                  },
                }}
                visible={isAuthenticated}
              />
              <Item
                location="before"
                widget="dxButton"
                options={{
                  elementAttr: {
                    class: "appheader__toolbar__button dx-state-selected",
                  },
                  text: "Administrare",
                  icon: "",
                  stylingMode: "text",
                }}
                visible={isAuthenticated}
              />
            </Toolbar>
            <DropDownButton {...userDropDownOptions} stylingMode="text" />
          </div>
        </CaseElse>
      </Switch>
    </React.Fragment>
  );
};
